/** @jsx jsx */
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import { Box, Heading, jsx, Text } from 'theme-ui'

const ArticlePrimaryFeaturedCard = ({ article }) => {
  const { category, description, image, slug, title } = article

  return (
    <Box>
      {image && (
        <Box>
          <Link to={`/blog/${slug}/`} aria-label={`Read ${title}`}>
            <GatsbyImage
              image={image.gatsbyImageData}
              alt={image.description}
              loading="eager"
              sx={{
                borderRadius: '8px 8px 0 0',
                img: {
                  transition: 'all 0.2s ease !important',
                },
                transform: 'translateZ(0)',
                '&:hover img': {
                  transform: 'scale(1.06)',
                },
              }}
            />
          </Link>
        </Box>
      )}
      <Box
        bg="white"
        pt={3}
        pb={4}
        px={[2, 4, 3, 4]}
        sx={{ borderRadius: '0 0 8px 8px' }}
      >
        {category && (
          <Text as="p" variant="subtitle2" mb={1}>
            {category.title}
          </Text>
        )}
        <Heading as="h3" variant="title3">
          <Link
            to={`/blog/${slug}/`}
            sx={{
              color: 'black',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            {title}
          </Link>
        </Heading>
        {description && (
          <Box
            mt={2}
            variant="text.body2"
            dangerouslySetInnerHTML={{
              __html: description.childMarkdownRemark.html,
            }}
            sx={{ p: { m: 0 } }}
          />
        )}
      </Box>
    </Box>
  )
}

ArticlePrimaryFeaturedCard.propTypes = {
  article: PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    description: PropTypes.shape({}),
    image: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
}

export default ArticlePrimaryFeaturedCard
